import { render, staticRenderFns } from "./PostOffice.vue?vue&type=template&id=65db6c9e&scoped=true&"
import script from "./PostOffice.vue?vue&type=script&lang=js&"
export * from "./PostOffice.vue?vue&type=script&lang=js&"
import style0 from "./PostOffice.vue?vue&type=style&index=0&id=65db6c9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65db6c9e",
  null
  
)

export default component.exports